export default {
  computed: {
    showTable() {
      for (let item in this.loadingItems) {
        if (this.loadingItems[item]) {
          return false
        }
      }
      return true
    },
    tableHeight() {
      return this.$store.getters.backendTableHeight
    }
  },
  methods: {
    handleSearch({ tableData, filterKeys, searchText } = {}) {
      if (!searchText) this.filterData = tableData
      else {
        this.filterData = tableData.filter(item => {
          for (let key of filterKeys) {
            if (item[key]?.includes(searchText)) return true
          }
          return false
        })
      }
      this.resetPageInfo(this.filterData)
    },
    resetPageInfo(data) {
      return Object.assign(this.pageInfo, {
        total: data.length,
        currentPage: 1,
        pageSize: 20
      })
    },
    resetTotal(data) {
      return Object.assign(this.pageInfo, {
        total: data.length,
        pageSize: 20
      })
    }
  }
}
